export const Loading = () => <p className='ifbLoading'>Loading...</p>
export default Loading;